// extracted by mini-css-extract-plugin
export var categoryIcon = "_cg-5";
export var connectorContainer = "_cg-1";
export var connectorLine = "_cg-0";
export var minHeight0 = "_cg-6";
export var relativeUnitValueSelector = "_cg-2";
export var trifoldSelectorBody = "_cg-4";
export var trifoldSelectorList = "_cg-3";